import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

const FADE_DURATION = 300;

const ConfirmationAlert = ({
  title,
  message,
  onConfirm,
  onCancel,
  confirmText,
  highlightType,
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  const handleClose = (action) => {
    setVisible(false);
    setTimeout(() => {
      if (action === "confirm") onConfirm();
      else onCancel();
    }, FADE_DURATION);
  };

  const modalContent = (
    <div
      className={`fixed inset-0 flex items-center justify-center z-[9999] transition-opacity duration-300 ${
        visible ? "opacity-100" : "opacity-0"
      }`}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" />

      {/* Modal */}
      <div
        className={`relative bg-white rounded-2xl shadow-2xl 
  w-[92%] sm:w-[420px] md:${highlightType ? "w-[460px]" : "w-[350px]"} 
  p-4 sm:p-6
  transform transition-all duration-300 ${
    visible ? "scale-100 opacity-100" : "scale-95 opacity-0"
  }`}
      >
        {/* UI  for Submit Candidate */}
        {highlightType ? (
          <div
            className={`flex gap-3 sm:gap-4 items-start rounded-lg p-3 sm:p-4 border 
  ${
    highlightType === "duplicate"
      ? "bg-red-50 border-red-200"
      : "bg-green-50 border-green-200"
  }`}
          >
            {/* Icon */}
            <div className="mt-1 text-2xl">
              {highlightType === "duplicate" ? "⚠️" : "✅"}
            </div>

            {/* Content */}
            <div className="flex-1">
              {/* Title */}
              <h2
                className={`text-base font-semibold mb-1 ${
                  highlightType === "duplicate"
                    ? "text-red-700"
                    : "text-green-700"
                }`}
              >
                {title}
              </h2>

              {/* Message */}
              <p className="text-gray-700 text-sm leading-relaxed">{message}</p>
            </div>
          </div>
        ) : (
          <>
            {/* Default UI*/}
            <h2 className="text-lg font-semibold text-gray-800 mb-2 text-center">
              {title || "Confirmation"}
            </h2>

            <p className="text-gray-600 mb-6 text-center">
              {message || "Do you want to proceed?"}
            </p>
          </>
        )}

        {/* Buttons */}
        <div className="flex justify-end gap-3 mt-5">
          <button
            onClick={() => handleClose("cancel")}
            className="px-4 py-2 rounded-lg border border-gray-300 bg-white hover:bg-gray-100 text-gray-700 transition"
          >
            Cancel
          </button>

          <button
            onClick={() => handleClose("confirm")}
            className="px-4 py-2 rounded-lg text-white transition shadow-md bg-blue-600 hover:bg-blue-700"
          >
            {confirmText ||
              (highlightType === "duplicate"
                ? "Yes, Proceed"
                : highlightType === "fresh"
                  ? "Yes, Continue"
                  : "Confirm")}
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default ConfirmationAlert;
